import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryInspectionList, queryUserTreeList, delInspectionItem, queryStandardTreeList } from '@/api/api';
import { httpAction, getAction } from '@/api/manage';
import DailyOperationReportModal from "./DailyOperationReportModal";
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import { addMonth, createMonthDate, formatDate } from '@/utils/cal';
import pick from 'lodash.pick';
import { queryFileList, querySiteTree } from "../../../../api/api";
export default {
  name: 'WorkSchedulingDrawer',
  mixins: [ModalFormMixin],
  components: {
    DailyOperationReportModal: DailyOperationReportModal,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      imgId: '',
      siteTree: [],
      title: '运维月报表单',
      tableName: 'om_inspection_report_ite',
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload',
      urlDownload: window._CONFIG['domianURL'] + '/sys/common/download/',
      showCopy: false,
      maxMonth: null,
      modalName: '水站参数配置',
      // 是否显示图片
      showImgModal: false,
      workList: [],
      schList: [],
      StandardListOptions: [],
      //departTreeData: [],

      /* 站点ID*/
      siteId: null,
      // 维护人员信息
      userTree: [],
      number: 1,
      dayList: [],
      showRed: false,
      //showMonth: false,
      month: '',
      showDate: false,
      showDept: false,
      errorIndex: null,
      errorClass: null,
      monthDay: null,
      url: {
        imageUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  props: ['pagePath'],
  watch: {
    model: {
      handler: function handler() {
        this.$forceUpdate();
      },
      deep: true
    }
    /*currentSiteId(value) {
     var ids = this.getTreeCurrentId()
     if (ids[0] == '1') {
       this.siteId = value
       this.queryParam.siteId = ids[1]
       // this.loadData()
     }
     if (ids[0] == '2') {
       this.queryParam.siteId = ids[1]
       // this.loadData()
     }
    },
    currentSiteName: {
     handler(value) {
       this.siteName = value
     },
     immediate: true
    }*/

  },
  created: function created() {
    this.getMonthValue();
    this.loadStandardTree();
    this.getSite();
  },
  methods: {
    changeUpload: function changeUpload(data, i, i1) {
      var _this = this;

      console.log(data, i, i1);
      console.log('this.editFirstState', this.editFirstState);

      if (this.editFirstState == true) {
        this.copyWorkList.forEach(function (item, index) {
          item.userList.forEach(function (item1, index1) {
            item1['passFileList'] = JSON.parse(JSON.stringify(_this.$refs["iwupload".concat(item1.date)][0].datasource));
          });
        });

        if (data.fileDelList.length > 0) {
          this.copyWorkList[i].userList[i1]['passFileList'] = data.fileDelList;
        }

        if (data.sysFileList.length > 0) {
          this.copyWorkList[i].userList[i1]['passFileList'].pop();
        }

        this.editFirstState = false;
        console.log('this.copyWorkList', this.copyWorkList);
      }
    },
    changeSite: function changeSite(value, label, data, index1) {
      var _this2 = this;

      console.log('this.month', this.month);
      data.siteId = value;
      data.siteName = label[0];
      var params = {};
      params.startTime = this.month.format('YYYY-MM');
      params.siteIds = value;
      getAction('/inspection/report/record/generateBySiteIds', params).then(function (res) {
        if (res.success) {
          console.log('res', res);

          if (res.result.length > 0) {
            _this2.workList[index1] = {
              id: null,
              name: null,
              siteId: data.siteId,
              siteName: data.siteName,
              userList: []
            };

            if (res.result[0].userList.length > 0) {
              res.result[0].userList.forEach(function (userItem, index2) {
                /*if (index2 < userItem.length - 1) {*/
                var v = {
                  id: null,
                  siteId: null,
                  inspectionDate: moment(userItem.inspectionDate),
                  waterQuality: null,
                  content: null,
                  maintenance: null,
                  abnormal: null,
                  userId: null,
                  remark: null,
                  delFlag: 0,
                  status: null,
                  date: new Date().getTime() + index2
                };

                _this2.workList[index1].userList.push(v);
                /* }*/


                return;
              });
            } else {
              _this2.workList[index1].userList.push({
                id: null,
                siteId: null,
                inspectionDate: null,
                waterQuality: null,
                content: null,
                maintenance: null,
                abnormal: null,
                userId: null,
                remark: null,
                delFlag: 0,
                status: null,
                date: new Date().getTime()
              });
            }

            var workList = _toConsumableArray(_this2.workList);

            _this2.workList = [];

            _this2.$nextTick(function () {
              console.log('workList', workList);
              _this2.workList = workList;

              _this2.$forceUpdate();
            });
          }
        }
      });
      console.log(this.workList);
    },
    getSite: function getSite() {
      var _this3 = this;

      // 用户
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this3.siteTree.push(temp);
          }
        }
      });
    },
    moment: moment,
    // 环境标准条目
    loadStandardTree: function loadStandardTree() {
      var that = this;
      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // 遍历到环境标准条目（第三层），把value前缀去掉
          for (var i = 0; i < res.result.length; i++) {
            var d1 = res.result[i];
            d1.selectable = false;

            if (null !== d1.children) {
              for (var c = 0; c < d1.children.length; c++) {
                var d2 = d1.children[c];
                d2.selectable = false;

                if (null !== d2.children) {
                  for (var c1 = 0; c1 < d2.children.length; c1++) {
                    var d3 = d2.children[c1];
                    d3.value = d3.value.toString().substring(3);
                  }
                }
              }
            }

            var temp = res.result[i]; // temp.value = temp.value.toString().substring(3)

            that.StandardListOptions.push(temp);
          }
        }

        that.StandardListOptions = that.StandardListOptions[0].children[1].children;
      });
    },
    getMonthValue: function getMonthValue() {
      var n = this.month;
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.workList = [];
      this.$emit('close');
      this.visible = false;
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },

    /* 递归获取图片*/
    toTreePicture: function toTreePicture(item) {
      var _this4 = this;

      if (item.id) {
        queryFileList('om_inspection_report_item', item.id).then(function (vo) {
          if (vo.success) {
            item.pictures = vo.result;
          }
        });

        if (item.children) {
          item.children.forEach(function (item, index) {
            _this4.toTreePicture(item);
          });
        }
      } else {
        return;
      }
    },
    // 查看文件
    openFile: function openFile(text) {
      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }

      this.imgId = this.getImgView(text);
      this.showImgModal = true;
    },
    // 图片预览
    getImgView: function getImgView(text) {
      return this.url.imgerver + '/' + text;
    },
    // 现场图片关闭
    setModal1Visible: function setModal1Visible() {
      this.showImgModal = false;
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this5 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this5.loading = false;
        }
      });
    },
    handleChange: function handleChange(value) {
      console.log(this.classId);
      console.log(value);
    },
    recordCl: function recordCl(siteId, item, value, type) {
      this.$refs.modelWork.edit(siteId, item, value, type);
    },

    /**
     * 添加运维报告行
     */
    addInspectionSite: function addInspectionSite() {
      /* if (this.model.inspectionDate && this.model.deptId) {*/
      var item = {
        id: null,
        name: null,
        userList: [{
          id: null,
          siteId: null,
          inspectionDate: null,
          waterQuality: null,
          content: null,
          maintenance: null,
          abnormal: null,
          userId: null,
          remark: null,
          delFlag: 0,
          status: null,
          date: new Date().getTime()
        }]
      };
      this.workList.push(item);
      this.$forceUpdate();
      this.autoNum();
    },

    /**
     * 添加运维报告行
     */
    addInspectionSites: function addInspectionSites(obj) {
      /* if (this.model.inspectionDate && this.model.deptId) {*/
      var item = {
        id: null,
        name: null,
        siteId: obj.siteId,
        siteName: obj.siteName,
        userList: []
      };
      this.workList.push(item);
      this.$forceUpdate();
      this.autoNum();
    },
    handleChangeState: function handleChangeState() {
      var _this6 = this;

      if (this.editFirstState == true) {
        this.copyWorkList.forEach(function (item, index) {
          item.userList.forEach(function (item1, index1) {
            item1['passFileList'] = JSON.parse(JSON.stringify(_this6.$refs["iwupload".concat(item1.date)][0].datasource));
          });
        });
        this.editFirstState = false;
        console.log('this.copyWorkList', this.copyWorkList);
      }
    },

    /**
     *添加巡检记录
     */
    addUser: function addUser(index) {
      var v = {
        id: null,
        siteId: null,
        inspectionDate: null,
        waterQuality: null,
        content: null,
        maintenance: null,
        abnormal: null,
        userId: null,
        remark: null,
        delFlag: 0,
        status: null,
        date: new Date().getTime()
      };
      this.workList[index].userList.push(v);
      this.$forceUpdate();
      this.autoNum();
    },

    /**
     *自动生成时添加巡检记录
     */
    addUserForRecord: function addUserForRecord(obj, index, index2) {
      var v = {
        id: null,
        siteId: null,
        inspectionDate: moment(obj.inspectionDate),
        waterQuality: null,
        content: null,
        maintenance: null,
        abnormal: null,
        userId: null,
        remark: null,
        delFlag: 0,
        status: null,
        date: new Date().getTime() + index + index2
      };
      this.workList[index].userList.push(v);
      this.$forceUpdate();
      this.autoNum();
    },

    /**
     *指定负责人
     */
    perCl: function perCl(index, index1) {
      var name = this.workList[index].userList[index1].name;
      this.workList[index].userList[index1].name = name ? null : '1';
    },

    /**
     *删除巡检记录
     */
    delUser: function delUser(key, index, index1, item, parentItem) {
      // if (key) {
      // delInspectionItem({
      // 	id: key
      // }).then((res) => {
      // this.workList[index].userList.splice(index1, 1)
      // if(this.workList[index].userList.length==0){
      // 	this.workList.splice(index,1)
      // 	this.$forceUpdate()
      // }
      // })
      // } else {
      if (this.model.id && item.id) {
        this.handleChangeState();
        var copyParentData = this.copyWorkList.filter(function (i) {
          return i.id === parentItem.id;
        });

        if (copyParentData.length > 0) {
          if (copyParentData[0].hasOwnProperty('userList')) {
            var copyData = copyParentData[0].userList.filter(function (data) {
              return item.id === data.id;
            })[0];
            console.log('copyData', copyData);
            copyData['delFlag'] = 1;
          }
        }
      }

      this.workList[index].userList.splice(index1, 1);

      if (this.workList[index].userList.length == 0) {
        this.workList.splice(index, 1);
        this.$forceUpdate();
      } // }


      console.log('this.workList', this.workList);
      this.$forceUpdate();
      this.autoNum();
    },

    /**
     *自动计算合并数
     */
    autoNum: function autoNum() {
      var _this7 = this;

      this.number = 1;
      this.workList.forEach(function (item) {
        item.userList.forEach(function (v) {
          _this7.number++;
        });
      });
    },

    /**
     *添加月份
     */
    autoDate: function autoDate(value, dateString) {
      this.showRed = false;
      this.showDept = false;
      var httpurl = this.pagePath;
      var method = 'post';
      var formData = {
        id: this.model ? this.model.id : null,
        inspectionDate: dateString,
        deptId: this.model ? this.model.deptId : null,
        siteId: this.currentSiteId
      };
    },
    copy: function copy(record) {
      this.showCopy = true;
      this.confirmLoading = true;
      this.editMany(record);
    },
    add: function add(record) {
      var _this8 = this;

      this.editFirstState = false;

      if (record) {
        /*record.forEach((item) => {
        var userList = []
        userList.push(item)
        this.workList.push(userList)
        })*/
        record.forEach(function (item, index1) {
          _this8.addInspectionSites(item);

          if (item.userList) {
            if (item.userList.length > 0) {
              item.userList.forEach(function (userItem, index2) {
                /*if (index2 < userItem.length - 1) {*/
                _this8.addUserForRecord(userItem, index1, index2);
                /* }*/


                return;
              });
            }
          } else {
            _this8.workList[index1].userList.push({
              id: null,
              siteId: null,
              inspectionDate: null,
              waterQuality: null,
              content: null,
              maintenance: null,
              abnormal: null,
              userId: null,
              remark: null,
              delFlag: 0,
              status: null,
              date: new Date().getTime() + index1
            });
          }
        });
        console.log(this.workList);
      }

      this.workList;
      this.$forceUpdate();
      this.showCopy = false;
      this.edit({
        generationTime: moment(new Date())
      });
    },
    edit: function edit(record) {
      var _this9 = this;

      console.log('record', record);
      this.copyWorkList = []; //   this.loadTreeList()

      this.showCopy = false;
      this.editMany(record);
      this.$nextTick(function () {
        var that = _this9;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal); // this.$refs.iwupload.loadUploadFiles()
      });
    },
    editMany: function editMany(record) {
      this.number = 1;
      this.workList = this.workList;
      this.dayList = [];
      this.schList = [];
      this.errorIndex = null;
      this.errorClass = null;
      this.loadTreeList(); //this.loadDepartTree()

      this.model = Object.assign({}, record);
      this.month = moment(record.month);
      this.mopt(this.model);
    },
    mopt: function mopt(value) {
      var _this10 = this;

      value.generationTime = value.generationTime ? moment(value.generationTime) : null;
      this.showRed = false;
      this.showDept = false;
      this.visible = true;
      this.autoNum();

      if (typeof value.id != 'undefined') {
        this.loadWork(value.id);
        setTimeout(function () {
          _this10.autoNum();

          if (_this10.showCopy) {
            _this10.copyDa(value);
          }
        }, 1000);
      }
    },
    copyDa: function copyDa(value) {
      var _this11 = this;

      var that = this;

      if (that.showCopy && that.maxMonth) {
        var copyData = value;
        copyData.inspectionDate = that.maxMonth ? addMonth(that.maxMonth) : null;
        copyData.workList = that.workList;
        copyData.dayList = that.dayList;
        var monthDay = createMonthDate(formatDate(copyData.inspectionDate, 'yyyy-MM-dd'));

        if (copyData.dayList.length > monthDay.length) {
          copyData.dayList.splice(monthDay.length - 1, copyData.dayList.length - monthDay.length);
          copyData.dayList.forEach(function (v, v_in) {
            monthDay.forEach(function (b, b_in) {
              if (v_in == b_in) {
                v.taskDay = b;
              }
            });
          });
        } else if (copyData.dayList.length < monthDay.length) {
          var moList = [];
          monthDay.forEach(function (v) {
            var item = {
              id: 0,
              taskDay: v,
              amClassId: 0,
              pmClassId: 0
            };
            moList.push(item);
          });
          moList.forEach(function (v, v_in) {
            copyData.dayList.forEach(function (b, b_in) {
              if (v_in == b_in) {
                v.id = b.id;
                v.amClassId = b.amClassId;
                v.pmClassId = b.pmClassId;
              }
            });
          });
          copyData.dayList = moList;
        } else {
          copyData.dayList.forEach(function (v, v_in) {
            monthDay.forEach(function (b, b_in) {
              if (v_in == b_in) {
                v.taskDay = b;
              }
            });
          });
        }

        var httpurl = '/mes/work/scheduling/copy/add';
        var method = 'post';
        httpAction(httpurl, copyData, method).then(function (res) {
          if (res.success) {
            that.showCopy = false;
            that.confirmLoading = false;

            _this11.$message_custom('复制成功');

            that.edit(res.result);
          } else {
            that.confirmLoading = true;

            _this11.$message_custom('系统出错，请联系管理员', 'warning');
          }
        }).finally(function () {
          that.showCopy = false;
          that.confirmLoading = false;
        });
      } else {}
    },

    /**
     * 加载巡检记录
     */
    loadWork: function loadWork(value) {
      var _this12 = this;

      var that = this;
      that.schList = [];
      that.editFirstState = true;
      queryInspectionList(value).then(function (res) {
        if (res.success) {
          var workList = [];

          if (res.result.hasOwnProperty('workList')) {
            res.result.workList.forEach(function (val, index) {
              if (val.userList) {
                if (val.userList.length > 0) {
                  val.userList.forEach(function (item, index1) {
                    _this12.toTreePicture(item);

                    item['date'] = new Date().getTime() + index + index1;
                    item.inspectionDate = item.inspectionDate ? moment(item.inspectionDate) : null;
                  });
                  workList.push(val);
                }
              }
            });
          }

          that.workList = workList;
          that.copyWorkList = JSON.parse(JSON.stringify(that.workList));
        }
      });
    },
    handleOk: function handleOk() {
      var _this13 = this;

      var that = this;

      if (that.model) {
        var httpurl = that.pagePath;
        var method = 'post';

        if (that.model.id) {
          method = 'put';
        }

        console.log('that.model', that.model);
        var formData = JSON.parse(JSON.stringify(that.model));
        formData.generationTime = formData.generationTime ? moment(formData.generationTime) : null;
        formData.generationTime = formData.generationTime ? formData.generationTime.format('YYYY-MM-DD HH:mm:ss') : null;
        that.month = that.month ? moment(that.month) : null;
        formData.month = that.month ? that.month.format('YYYY-MM') : null;
        formData.workList = JSON.parse(JSON.stringify(that.workList));
        formData.siteId = that.siteId;
        formData.workList.forEach(function (work, index) {
          work.userList.forEach(function (e, i) {
            e = that.$refs["iwupload".concat(e.date)][0].getUploadListToFromData(e);
            formData.workList[index].userList[i] = e;
          });
        }); //formData = this.$refs.iwupload[0].getUploadListToFromData(formData)

        var canSubmit = true;

        if (that.model.id) {
          // 数组合并
          that.copyWorkList.forEach(function (item, index) {
            formData.workList.forEach(function (item1, index1) {
              if (item.id == item1.id) {
                item.userList = [].concat(_toConsumableArray(item.userList), _toConsumableArray(item1.userList));
              }
            });
          }); // 数组去重

          var _iterator = _createForOfIteratorHelper(that.copyWorkList),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              var newJson = [];

              for (var i = 0; i < item.userList.length; i++) {
                var flag = true;
                var item1 = item.userList[i];

                if (item1.id) {
                  for (var j = 0; j < newJson.length; j++) {
                    var item2 = newJson[j];

                    if (item1.id == item2.id) {
                      var data = JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, item2), item1)));
                      newJson[j] = data;
                      flag = false;
                    }
                  }
                }

                if (flag) {
                  newJson.push(item1);
                }
              }

              item.userList = newJson;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          formData.workList = that.copyWorkList;
          formData.workList.forEach(function (item) {
            var delFlag = 1;
            item.userList.forEach(function (item1) {
              if (item1.delFlag == 0) {
                delFlag = 0;
              } else {
                item1.fileDelList = JSON.parse(JSON.stringify(item1.passFileList));
                delete item1.passFileList;
              }

              item1['siteId'] = item.siteId - 0;
              item1['siteName'] = item.siteName;
              item1['pid'] = item.id;
            });
            item['delFlag'] = delFlag;
          });
          console.log('formData', formData);
        }

        try {
          formData.workList.forEach(function (v, index) {
            var val = false;
            /*202220202运维报告*/

            if (v.userList != null) {
              v.userList.forEach(function (item) {
                item.inspectionDate = item.inspectionDate ? moment(item.inspectionDate) : null;
                item.inspectionDate = item.inspectionDate ? item.inspectionDate.format('YYYY-MM-DD HH:mm:ss') : null;
                if (item.hasOwnProperty('date')) delete item.date; // 非空验证

                /*if (!item.tel || !item.userId) {
                val = true
                }*/
              });

              if (val) {
                canSubmit = false;
                that.errorIndex = index;

                _this13.$message_custom('必填项不能为空', 'error');

                throw new Error('End');
              }
            }
          });
        } catch (e) {
          if (e.message === 'End') throw e;
        }

        try {
          formData.dayList.forEach(function (v, index) {
            if (!v.amClassId || !v.pmClassId) {
              canSubmit = false;
              that.errorClass = index;

              _this13.$message_custom('请选择', 'error');

              throw new Error('End');
            }
          });
        } catch (e) {
          if (e.message === 'End') throw e;
        }

        console.log('formData', formData);

        if (canSubmit) {
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this13.$message_custom(res.message);

              that.$emit('ok');
              that.close();
            } else {
              _this13.$message_custom(res.message, 'warning');
            }
          }).finally(function () {
            that.errorIndex = null;
            that.errorClass = null;
            that.confirmLoading = false;
          });
        }
      }
    },

    /**
     * 过滤
     * @param input
     * @param option
     * @returns {boolean}
     */
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};